import React, {Component} from "react";
import PropTypes from "prop-types";
import DatePicker from "material-ui/DatePicker";
import {FieldTitle} from "admin-on-rest";

export const datify = input => {
  if (!input) {
    return null;
  }

  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date)) {
    throw new Error(`Invalid date: ${input}`);
  }

  return date;
};

class DateInput extends Component {
  state = {
    value: this.props.input.value
  };

  componentDidMount() {
    this.setState({value: this.props.input.value});
  }

  onChange = (_, date) => {
    this.props.input.onChange(date.toISOString());
    this.props.input.onBlur();
  };

  onBlur = () => {};

  onDismiss = () => this.props.input.onBlur();

  render() {
    const {
      input,
      isRequired,
      label,
      meta,
      options,
      source,
      elStyle,
      resource,
      inputStyle,
      floatingLabelStyle,
      underlineStyle,
      underlineFocusStyle,
      underlineShow,
      hintStyle
    } = this.props;
    if (this.state.value) this.props.input.value = this.state.value;
    if (typeof meta === "undefined") {
      throw new Error(
        "The DateInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const {touched, error} = meta;

    return (
      <DatePicker
        {...input}
        errorText={touched && error}
        floatingLabelText={
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        }
        DateTimeFormat={Intl.DateTimeFormat}
        container="inline"
        autoOk
        value={datify(input.value)}
        onChange={this.onChange}
        onBlur={this.onBlur}
        onDismiss={this.onDismiss}
        style={elStyle}
        inputStyle={inputStyle}
        floatingLabelStyle={floatingLabelStyle}
        underlineStyle={underlineStyle}
        underlineFocusStyle={underlineFocusStyle}
        underlineShow={underlineShow}
        hintStyle={hintStyle}
        {...options}
      />
    );
  }
}

DateInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string
};

DateInput.defaultProps = {
  addField: true,
  options: {}
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/CRM/DateInput.js